import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlTree } from '@angular/router';
import {
  CompanyModuleService,
  CompanyToolsService,
} from '@web-frontend/shared/services/company';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanyModuleGuard implements CanLoad {
  constructor(
    private companyModuleService: CompanyModuleService,
    private companyToolsService: CompanyToolsService
  ) {}

  canLoad(route: Route): Observable<boolean | UrlTree> {
    const { modules = [], tools = [] } = route.data;

    if (tools.length > 0) {
      return this.companyToolsService.activeTools$.pipe(
        filter((activeTools) => activeTools !== null),
        take(1),
        map((activeTools) =>
          activeTools.some((activeTool) => tools.includes(activeTool.id))
        ),
        tap((res) => {
          if (!res) {
            this.companyModuleService.goFirstRouteActive();
          }
        })
      );
    }

    return this.companyModuleService.activeModules$.pipe(
      filter((activeModules) => activeModules !== null),
      take(1),
      map((activeModules) =>
        activeModules.some((activeModule) => modules.includes(activeModule.id))
      ),
      tap((res) => {
        if (!res) {
          this.companyModuleService.goFirstRouteActive();
        }
      })
    );
  }
}
